import {
  Directive,
  Input,
  HostBinding,
  HostListener,
  ElementRef,
  EventEmitter,
  Inject,
  NgZone,
  OnInit,
  OnDestroy,
  Output,
  ChangeDetectorRef,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { Observable } from 'rxjs';

import { DropdownService } from './dropdown.service';
import {takeWhile} from 'rxjs/operators';
import {fromEvent} from 'rxjs/internal/observable/fromEvent';


@Directive({
  selector: '[dropdown]',
  exportAs: 'dropdown',
  providers: [DropdownService]
})
export class DropdownDirective implements OnInit, OnDestroy {

  @HostBinding('class.dropup') @Input() dropup: boolean = false;

  @HostBinding('class.btn-group') btnGroup: boolean = true;

  @HostBinding('class.dropgroup') dropgroup: boolean = true;

  @HostBinding('class.show') isOpened: boolean = false;

  @Output() dropdownOpen: EventEmitter<boolean> = new EventEmitter<boolean>();

  private isActive: boolean = true;

  constructor(
    private dropdownService: DropdownService,
    private _elementRef: ElementRef,
    private ngZone: NgZone,
    private ref: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: any,
  ) {}

  ngOnInit() {
    this.dropdownService.isOpened
    .pipe(takeWhile(() => this.isActive))
    .subscribe((value: boolean) => {
      if (this.isOpened === value) { return; }
      this.isOpened = value;
      this.ref.detectChanges();
      this.dropdownOpen.emit(this.isOpened);
    });
    this.ngZone.runOutsideAngular(() => {
      fromEvent(this.document, 'click')
      .pipe(takeWhile(() => this.isActive))
      .subscribe((event: MouseEvent) => {
        this.onDocumentClick(event);
      });
    });
  }

  ngOnDestroy() {
    this.isActive = false;
    this.ref.detach();
  }

  onDocumentClick(event: any): void {
    if (this.dropdownService.isOpenedValue &&
        !this._elementRef.nativeElement.contains(event.target)) {
      this.close();
    }
  }

  public toggle() {
    this.dropdownService.toggle();
  }

  public show() {
    this.dropdownService.show();
  }

  public close() {
    this.dropdownService.close();
  }

}
